<template>
    <span>
        <el-button type="text" size="large" @click="dialogFormVisible = true" >配置筛选条件</el-button>
        <el-dialog title="配置筛选条件" :visible.sync="dialogFormVisible" center @close="searchConfigClose">
            <div v-for="(group, index) in fields" :key="index">
                <el-row class="searchSection">
                    <el-col :span="6">
                        {{group.label}}
                    </el-col>
                    <el-col :span="3" :offset="15">
                        <el-checkbox :indeterminate="group_form[group.field + '_is_indeterminate']" v-model="group_form[group.field + '_check_all']" @change="handleCheckAllChange($event, group)">全选</el-checkbox>
                    </el-col>
                    <el-divider class="el-divider-config"></el-divider>
                </el-row>
                <el-checkbox-group v-model="group_form[group.field + '_check_fields']" @change="handleCheckedChange($event, group)">
                    <el-checkbox v-for="(child, child_index) in group.children" :label="child.field" :key="child_index">{{child.label}}</el-checkbox>
                </el-checkbox-group>
                <br>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()" :loading="submiting">确 定</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<style scoped>
  .el-divider-config {
    margin: 35px 10px 0 0;
  }
</style>
<script>
import CommonService from "~/services/common";

export default{
    name: "SearchConfig",

    components: {
    },
    
    props: {
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },

        fields: {
            type: Array,
            required: true,
        },

        cache_field: {
            type: String,
            required: true,
        },

        // dialogFormVisible: {
        //     type: Boolean,
        //     required: false,
        // },
    },
    
    data() {
        return {
            dialogFormVisible: false,
            group_form: {
                // base_is_indeterminate: false,
                // base_check_all: false,
                // base_check_fields: [],
                // date_is_indeterminate: false,
                // date_check_all: false,
                // date_check_fields : [],
                // other_is_indeterminate: false,
                // other_check_all: false,
                // other_check_fields : [],
            },
            checked_field: [],
            isIndeterminate: true,
            checkAll: false,
            submiting: false,
        }
    },

    created: function () {
        if(this.$store.getters.cache && this.$store.getters.cache.hasOwnProperty(this.cache_field)){
            this.group_form = this.$store.getters.cache[this.cache_field];
        }else{
            this.fields.forEach(group => {
                this.$set(this.group_form, group.field + '_is_indeterminate', false);
                this.$set(this.group_form, group.field + '_check_fields', []);
                this.$set(this.group_form, group.field + '_check_all', false);
                //默认是全选中
                this.handleCheckAllChange(true, group);
            });
        }
        // console.log('fields:', this.fields, this.$store.getters.cache, this.group_form, this.$route);
    },
    
    methods: {
        handleCheckAllChange(value, group) {
            // console.log('全选: ', value, group);
            const allFields = [];
            group.children.forEach(child => {
                allFields.push(child.field);
            });
            this.group_form[group.field + '_check_fields'] = value ? allFields : [];
            this.group_form[group.field + '_check_all'] = value;
        },

        handleCheckedChange(value, group) {
            // console.log('单个勾选: ', value, group);
            let checkedCount = value.length;
            this.group_form[group.field + '_check_fields'] = value;
            this.group_form[group.field + '_is_indeterminate'] = checkedCount > 0 && checkedCount < group.children.length;
            this.group_form[group.field + '_check_all'] = checkedCount === group.children.length;
        },

        searchConfigClose(){
            // this.$emit("close", true);
        },

        save(){
            // 发起更新
            this.submiting = true;
            CommonService.setUserCache({key: this.cache_field, value: this.group_form}).then(res => {
                if (res && res.data) {
                    this.$message({
                        type: "success",
                        message: "配置成功！"
                    });
                    this.$store.getters.cache[this.cache_field] = this.group_form;
                }
                this.submiting = false;
                this.dialogFormVisible = false;
                this.$emit("close", true);
            }).catch(err => {
                this.submiting = false;
                console.error(err);
            });
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/widgets/dialog/SearchConfig.vue